

exports.__esModule = true;
exports.$LandingRoute = undefined;

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _auth = require('xo-models/src/auth');

var _squid = require('squid');

var _index = require('xo-models/src/checkout/index');

var _index2 = require('xo-models/src/credit/index');

var _credit = require('xo-models/src/credit');

var _inventory = require('xo-models/src/inventory');

var $LandingRoute = exports.$LandingRoute = _squid.$ComponentRoute.extend('$LandingRoute', {
    path: 'landing',
    trackingData: {
        fptiState: 'landing',
        trackStateExit: true
    },
    auth: false,
    resolve: {

        action: function action() {

            var models = {};

            return (0, _squid.$populate)(models, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _index.$CheckoutCartModel.instance(_angular.$rootScope.token),
                auth: _auth.$AuthModel.instance(),
                checkoutPayeeModel: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                flowEligibility: _index.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
                    params: {
                        localeCountry: _squid.$locale.country, // We need this till we completely migrate to server side locale resolution
                        braintreeInegration: _squid.$util.param('bt_int_type') === '2' ? 'SFAuthSession' : '',
                        fundingSource: _squid.$util.param('fundingSource')
                    }
                })
            }).then(function () {
                var forced_signup_offered = models.flowEligibility.guest ? 0 : 1;

                _logger.$logger.info('checkout_fpti', { 'from': 'LANDING_PAGE_PARAM', 'forced_signup_offered': forced_signup_offered });

                var landingFlow = function landingFlow() {
                    var merchantCountry = models.checkoutAppData.get('merchant.merchant_country', 'US');
                    var supportBlockNonDomesticShipping = (0, _squid.$feature)('supportBlockNonDomesticShipping', false, merchantCountry);
                    var prefillShippingAddress = models.checkoutCart.get('purchase.shipping_address');
                    var blockNonDomesticShipping = models.checkoutAppData.get('flags.block_non_domestic_shipping');
                    var allowChangeShipping = models.checkoutAppData.get('flags.allow_change_shipping');

                    if (supportBlockNonDomesticShipping && blockNonDomesticShipping) {
                        _logger.$logger.info('block_non_domestic_shipping', {
                            block_non_domestic_shipping: blockNonDomesticShipping,
                            allow_change_shipping: allowChangeShipping,
                            setec_shipping_country_code: prefillShippingAddress
                        });
                    }

                    var shouldBlockBuyer = supportBlockNonDomesticShipping && blockNonDomesticShipping && !allowChangeShipping && prefillShippingAddress && prefillShippingAddress.country_code !== merchantCountry && prefillShippingAddress.country_code !== '';

                    if (shouldBlockBuyer) {
                        return {
                            to: 'checkout.genericError',
                            params: {
                                code: 'BLOCK_NON_DOMESTIC_SHIPPING'
                            }
                        };
                    }

                    var isPayPalCredit = models.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

                    if (isPayPalCredit) {
                        var creditDataModel = _credit.$CreditDataModel.instance(_angular.$rootScope.token);
                        var isCapeReturnKey = creditDataModel.getCapeKey();
                        var offers = new _index2.$CreditInstallmentOptionsModel({
                            id: _angular.$rootScope.token,
                            payee: models.checkoutPayeeModel,
                            checkoutCart: models.checkoutCart,
                            checkoutAppData: models.checkoutAppData,
                            isMemberCredit: true
                        });
                        var isInstallmentEligible = models.flowEligibility && models.flowEligibility.installment;
                        var country = models.checkoutAppData.get('merchant.merchant_country');
                        var installmentOptions = void 0;

                        return offers.save({
                            cache: true,
                            success: function success() {
                                installmentOptions = offers.getInstallmentOptionsPresent();

                                if (isCapeReturnKey) {
                                    if (country === 'DE') {
                                        return 'checkout.xoDeGuest';
                                    }
                                    return 'checkout.login';
                                } else if (country === 'GB' || isInstallmentEligible && installmentOptions) {
                                    _logger.$logger.info('ppc_second_btn_acquisition');
                                    return 'checkout.chooseCreditOffer';
                                } else if (country === 'DE') {

                                    if (installmentOptions) {

                                        return 'checkout.chooseCreditOffer';
                                    } else {

                                        return {
                                            to: 'checkout.genericError',
                                            params: {
                                                code: 'BLOCK_PPC_INELIGIBLE_USER'
                                            }
                                        };
                                    }
                                } else {
                                    _logger.$logger.info('ppc_second_btn_resuse');
                                    return 'checkout.login';
                                }
                            },
                            contingencies: {
                                DEFAULT: function DEFAULT(name, err) {
                                    // Check error message === currencyNotCompatible
                                    return 'checkout.login';
                                }
                            }
                        });
                    }

                    return 'checkout.login';
                };

                var cartHasInventory = models.checkoutCart.get('cartHasInventory');

                if (_squid.$config.enableInventoryWPS && cartHasInventory) {
                    var inventoryModel = _inventory.$InventoryModel.instance(_angular.$rootScope.token);
                    var inventoryInput = {
                        items: models.checkoutCart.get('purchase.items'),
                        merchantId: models.checkoutPayeeModel.getId()
                    };

                    return inventoryModel.action('getInventory', {
                        data: inventoryInput,
                        success: function success(inventoryResponse) {
                            if (inventoryResponse.showSoldoutPage) {
                                return {
                                    to: 'checkout.soldout',
                                    params: {
                                        items: encodeURIComponent(inventoryResponse.soldoutItems),
                                        soldOutUrl: encodeURIComponent(inventoryResponse.soldoutUrl)
                                    }
                                };
                            } else {
                                inventoryModel.setInvetoryItems(inventoryResponse);
                                return landingFlow();
                            }
                        }
                    });
                } else {
                    return landingFlow();
                }
            });
        }
    }
});

angular.value("$LandingRoute", $LandingRoute);
_angular.$rootScope;

_logger.$logger;

_auth.$AuthModel;

_squid.$Class;

_squid.$ComponentRoute;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$util;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$FlowEligibilityModel;

_index.$CheckoutAppDataModel;

_index2.$CreditInstallmentOptionsModel;

_credit.$CreditDataModel;

_inventory.$InventoryModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-landing/route.js
// module id = ./pages/xo-landing/route.js
// module chunks = 0